import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Star } from 'lucide-react';
export function TestimonialsShort() {
  const testimonials = [{
    initials: 'MG',
    text: 'Entendí en una tarde por qué mi hijo reacciona así. Ahora sé exactamente qué necesita en cada momento.',
    name: 'María G.',
    location: 'Buenos Aires',
    childInfo: 'Mamá de Tomás, 5 años'
  }, {
    initials: 'LC',
    text: 'Las peleas por la tarea desaparecieron cuando entendí su elemento de aprendizaje. El Tomo 3 me cambió todo.',
    name: 'Laura C.',
    location: 'Medellín',
    childInfo: 'Mamá de Sofía, 8 años'
  }, {
    initials: 'PR',
    text: 'Pensé que era misticismo. Hoy es mi herramienta más práctica. Mis tres hijos tienen elementos distintos y por fin los entiendo a los tres.',
    name: 'Patricia R.',
    location: 'Ciudad de México',
    childInfo: 'Mamá de 3 hijos'
  }];
  return <SectionWrapper data-id="element-268">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-269">
        {testimonials.map((t, i) => <div key={i} className="bg-card-bg p-8 rounded-2xl shadow-sm border border-dusty-rose/20 flex flex-col h-full" data-id="element-270">
            <div className="flex items-center gap-4 mb-4" data-id="element-271">
              <div className="w-12 h-12 rounded-full bg-dusty-rose/20 flex items-center justify-center text-burgundy font-bold text-lg" data-id="element-272">
                {t.initials}
              </div>
              <div className="flex text-gold" data-id="element-273">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-274" />)}
              </div>
            </div>

            <p className="text-text-main/90 italic mb-6 flex-grow" data-id="element-275">
              "{t.text}"
            </p>

            <div className="mt-auto" data-id="element-276">
              <p className="font-bold text-burgundy" data-id="element-277">{t.name}</p>
              <p className="text-xs text-text-main/60 mt-1" data-id="element-278">
                {t.location} | {t.childInfo}
              </p>
            </div>
          </div>)}
      </div>
    </SectionWrapper>;
}